import useSearchProductsByCategory from './useSearchProductsByCategory'
export default useSearchProductsByCategory
